export default "__VITE_ASSET__BqGX0fT9__"